import { Copy, Eye, Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ReadOnlyChatBannerProps {
  ownerUsername: string;
  isCopying: boolean;
  onContinueCopy: () => void;
}

/** Replaces the composer in another user's chat. */
export function ReadOnlyChatBanner({ ownerUsername, isCopying, onContinueCopy }: ReadOnlyChatBannerProps) {
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-3 border-t border-surface-200 bg-surface-50 px-4 py-3 dark:border-surface-800 dark:bg-surface-900"
    >
      <span className="flex items-center gap-2 text-sm text-surface-700 dark:text-surface-300">
        <Eye className="h-4 w-4 shrink-0" aria-hidden="true" />
        Read-only. This chat belongs to {ownerUsername}.
      </span>
      <Button size="sm" onClick={onContinueCopy} disabled={isCopying}>
        {isCopying ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Copy className="mr-2 h-4 w-4" />}
        Continue a copy
      </Button>
    </div>
  );
}
